/* ==========================================================================
   FPC — Drop page client behaviour.
   Loaded ONCE per page on the drop template AND the homepage, via
   snippets/_init-theme-head-custom.liquid (same gate as fpc-base.css). Each
   feature is DOM-agnostic: it no-ops when its
   target elements aren't on the page, so it's safe to load template-wide.
   ========================================================================== */
(function () {
  'use strict';

  /* --- Sticky bar spacer ---------------------------------------------------
     The drop bar is position:fixed, so reserve matching bottom padding on the
     page or it covers the footer. Its height varies (the message wraps on
     narrow screens), so measure and re-sync on resize / content change. */
  function initDropbarSpacer() {
    if (!document.querySelector('.dropbar')) return;

    function sync() {
      var active = document.querySelector('.dropbar.on');
      document.body.style.paddingBottom = active ? active.offsetHeight + 'px' : '';
    }

    sync();
    window.addEventListener('load', sync);
    window.addEventListener('resize', sync);
    document.addEventListener('shopify:section:load', sync);
    document.addEventListener('shopify:section:unload', sync);

    var bar = document.querySelector('.dropbar');
    if (bar && window.ResizeObserver) new ResizeObserver(sync).observe(bar);
  }

  /* --- New Drop rail -------------------------------------------------------
     Wires the arrow buttons of each horizontal product rail ([data-drop-rail],
     homepage New Drop) to scroll it, and reflects the rail's position by
     disabling the prev/next button at each end (and hiding both when the rail
     doesn't overflow). Touch/trackpad scrolling works without JS; this only
     adds the arrow affordance. No-ops when no rail is present, and is safe to
     call again (guarded) for theme-editor section reloads. */
  function wireRail(rail) {
    if (rail.dataset.railReady) return;
    rail.dataset.railReady = '1';

    var wrap = rail.closest('.railwrap') || rail.parentNode;
    var prev = wrap.querySelector('[data-rail-prev]');
    var next = wrap.querySelector('[data-rail-next]');

    function step() { return Math.min(rail.clientWidth * 0.8, 900); }

    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      var overflows = max > 1;
      var x = rail.scrollLeft;
      if (prev) prev.disabled = !overflows || x <= 1;
      if (next) next.disabled = !overflows || x >= max - 1;
    }

    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(rail);
    update();
  }

  function initDropRail() {
    document.querySelectorAll('[data-drop-rail]').forEach(wireRail);
  }

  initDropbarSpacer();
  initDropRail();
  document.addEventListener('shopify:section:load', initDropRail);
})();
